import React from "react";
import PropTypes from "prop-types";

import { CenteredElement, LogoImgElement, TitleElement } from "./LogoTitle.styles";

const RechargeLogo = ({
  src,
  alt,
  text,
  logoMarginBottom,
  logoMarginTop,
  titleMaxWidth,
  titleMarginBottom,
  titleFontSizeMedium,
  titleMaxWidthMedium,
  logoHeight,
  logoWith,
  tittleFontSize,
}) => {
  return (
    <CenteredElement>
      {src && (
        <LogoImgElement
          src={src}
          alt={alt}
          logoMarginBottom={logoMarginBottom}
          logoMarginTop={logoMarginTop}
          logoWith={logoWith}
          logoHeight={logoHeight}
        />
      )}
      <TitleElement
        titleMaxWidth={titleMaxWidth}
        titleMarginBottom={titleMarginBottom}
        titleFontSizeMedium={titleFontSizeMedium}
        titleMaxWidthMedium={titleMaxWidthMedium}
        tittleFontSize={tittleFontSize}
      >
        {text}
      </TitleElement>
    </CenteredElement>
  );
};

RechargeLogo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  logoMarginBottom: PropTypes.number,
  logoMarginTop: PropTypes.number,

  titleMaxWidth: PropTypes.number,
  titleMarginBottom: PropTypes.number,
  titleFontSizeMedium: PropTypes.number,
  titleMaxWidthMedium: PropTypes.number,
  logoWith: PropTypes.number,
  logoHeight: PropTypes.number,
  tittleFontSize: PropTypes.number,
};

RechargeLogo.defaultProps = {
  src: undefined,
  logoMarginBottom: 25,
  logoMarginTop: 25,

  titleMaxWidth: 200,
  titleMarginBottom: 25,
  titleFontSizeMedium: undefined,
  titleMaxWidthMedium: undefined,
  logoWith: undefined,
  logoHeight: undefined,
  tittleFontSize: undefined,
};

export default RechargeLogo;
